import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

/**
 * Protected Route Component
 * Redirects to login if user is not authenticated
 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  
  if (!isAuthenticated()) {
    console.log('❌ Not authenticated, redirecting to login');
    // Save the attempted location so we can redirect back after login
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}
